import { RequestListSearchResponse } from '@Types/api/requestList';
import { parseDateTime } from '@Utils/transformDateTime';
import { TypeDict } from '@Types/index';
import { OptionNum } from '@Components/types/options';
import { ResignationRequestFormResponse } from '@Types/api/form';
import { EMPTY_FIELD_PLACEHOLDER } from '@Constants';

import { ColumnDataType } from './type';

export const dataSourceMap = (
  data: RequestListSearchResponse<ResignationRequestFormResponse>,
  findStatus: (statusNum: number) => TypeDict | undefined,
  reasonOptions: OptionNum[]
): Array<ColumnDataType> => {
  if (!data?.content) return [];

  return data?.content?.map((requestItem) => {
    const matchedReason = reasonOptions.find(
      (reasonItem) => reasonItem.value === requestItem.reason
    )?.label;
    const matchedStatus = findStatus(requestItem.statusId)?.codeDesc;

    const resignationDate = parseDateTime(requestItem.resDate);
    const lastWorkingDate = parseDateTime(requestItem.lastWrkngDate);
    const createdDate = parseDateTime(requestItem.createdDate);

    const output = {
      key: requestItem.requestId,
      requestNo: requestItem.requestId,
      empNumber: requestItem.empNumber,
      empName: requestItem.empName,
      approverName: requestItem.approverName,
      resignationDate,
      lastWorkingDate,
      letterOfContent: requestItem.letterContent || EMPTY_FIELD_PLACEHOLDER,
      reason: matchedReason || EMPTY_FIELD_PLACEHOLDER,
      createdDate,
      status: matchedStatus || '',
      action: '',
    };
    return output;
  });
};
